/* eslint-disable */
"use strict"
import Vue from "vue"
import store from "../store"
import { v4 as uuidv4 } from "uuid"
import { AxiosInstance } from "axios"

class Axios {
  public axios: AxiosInstance
  private cache: Object[]
  private uuid: any
  private vue: any

  constructor() {
    this.uuid = uuidv4()
    this.vue = new Vue({ store })
    this.axios = Vue.prototype.$http
    this.cache = JSON.parse(localStorage.getItem("requests") as any)
  }

  static async sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  async offlineRequest({ vuex, ...paylod }: any) {
    if (paylod.data) {
      paylod.data.uuid = paylod.data?.uuid ?? this.uuid
    }

    if (paylod.method.toLowerCase() == "patch") {
      paylod.data.requested_at = this.vue
        .$moment()
        .format("YYYY-MM-DD HH:mm:ss")
    }
    let cachePaylod = { ...paylod, id: this.uuid, vuex }

    if (!this.cache) {
      this.vue.$store.commit("updateStorage", [cachePaylod])
    } else {
      this.cache.push(cachePaylod)
      this.vue.$store.commit("updateStorage", this.cache)
    }

    if (paylod.data) {
      paylod.data.abnormalities = paylod.data.abnormalitiesArray
      paylod.data.jobs = paylod.data.jobsArray
      paylod.data.pendencies = paylod.data.pendenciesArray
    }
    return Promise.resolve({ data: paylod.data })
  }
  /**  Metodo utilizado para requisições passiveis de cache em caso de usuário sem rede */
  async request(paylod: any) {
    if (!navigator.onLine) {
      if (paylod.method.toLowerCase() != "get" && paylod.offline) {
        return this.offlineRequest(paylod)
      }
    }
    const result = await this.axios.request(paylod)
    return result
  }
}

export default Axios
